module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-fm",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "vep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Snow is white and lieth in the dike,")])]), _vm._v(" "), _c('p', {
    staticClass: "vep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("And every man lets it lie;")])]), _vm._v(" "), _c('p', {
    staticClass: "vep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Pepper is black and hath a good smack,")])]), _vm._v(" "), _c('p', {
    staticClass: "vep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("And every man doth it buy.")])]), _vm._v(" "), _c('p', {
    staticClass: "vepc"
  }, [_vm._v("—A “COMMONPLACE BOOK” OF THE FIFTEENTH CENTURY")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("… we were “not so much sub-continent as sub-condiment,” as my distinguished mother had it. “From the beginning, what the world wanted from bloody mother India was daylight-clear,” she’d say. “They came for the hot stuff, just like any man calling on a tart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—SALMAN RUSHDIE, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("THE MOOR’S LAST SIGH")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f373401","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraphs.vue
// module id = 75
// module chunks = 0